import { createSelector } from '@ngrx/store';

import * as fromReducer from '@billing/store/reducers/billing-info.reducer';
import { BillingState } from '@billing/store/state/billing.state';
import { billingRootSelector } from '@billing/store/selectors/billing-root.selector';

export const getBillingInfoState = createSelector(
  billingRootSelector,
  (state: BillingState) => state.billingInfo
);

export const selectBillingInfoIds = createSelector(getBillingInfoState, fromReducer.selectIds);
export const selectBillingInfoEntities = createSelector(getBillingInfoState, fromReducer.selectEntities);
export const selectAllBillingInfo = createSelector(getBillingInfoState, fromReducer.selectAll);
export const selectTotalBillingInfo = createSelector(getBillingInfoState, fromReducer.selectTotal);
